<template>
    <div></div>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"

export default {
    name: "FormStoreEmbedded",

    mixins: [formMixin],

    props: {
        formProp: {
            required: true,
            type: Object,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore",
        },
    },

    data() {
        return {}
    },

    async created() {
        this.$store.dispatch(`${this.formStore}/form/set`, this.formProp)
    },

    computed: {
    },

    mounted() {},

    methods: {
    },

    watch: {
    },
}
</script>

<style lang="scss" scoped></style>
